import { render, staticRenderFns } from "./DefaultContent-Home.vue?vue&type=template&id=5ea4ccf4&"
import script from "./DefaultContent-Home.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports